import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';


@Injectable({
  providedIn: 'root'
})
export class GerenciarPreferenciasService {
  token = sessionStorage.getItem('accessTokenJWT');
  optUrl = 'https://uat-api.serasaexperian.com.br/lgpd/opt/v1/opt';
  userOptMeio: number;
  userOptOrigem: number;
  
  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type':  'application/json',
      'Authorization': 'Bearer ' + this.token
    })
  };

  constructor(private http: HttpClient) {
    if (environment.production) {
      this.optUrl = 'https://api.serasaexperian.com.br/lgpd/opt/v1/opt';
    }
  }

  getUserStatus() {
    let response = this.http.get(this.optUrl, this.httpOptions);
    return response;
  }

  postNewStatus(bodyReq: any) : Observable<any> {
    return this.http.post(this.optUrl, bodyReq, this.httpOptions);    
  }
}
